{
  "welcome": {
    "title": "Welcome to Tworks",
    "subtitle": "Organize your work, capture ideas with your voice, and let AI help you not forget anything.",
    "create_account": "Create account",
    "have_account": "I already have an account"
  },
  "tour": {
    "skip": "Skip",
    "start": "Get started",
    "next": "Next",
    "slides": {
      "tasks_title": "Your tasks, simple",
      "tasks_body": "Create, assign, and complete tasks in seconds.",
      "meetings_title": "Smart meetings",
      "meetings_body": "Record and AI extracts the tasks automatically.",
      "team_title": "Team work",
      "team_body": "Share projects with your team in real time."
    }
  },
  "permissions": {
    "title": "Permissions",
    "notifications_title": "Notifications",
    "notifications_subtitle": "We notify you when you're assigned a task or someone comments on yours.",
    "mic_title": "Microphone",
    "mic_subtitle": "To record meetings and extract tasks with AI. Audio is processed on our server and deleted after 90 days.",
    "allow": "Allow",
    "activated": "✓ Enabled",
    "open_settings": "Enable in Settings",
    "continue": "Continue"
  },
  "oem": {
    "title": "Important setup",
    "warning_html": "Your <strong>{device}</strong> has a battery optimizer that can close Tworks while you're recording meetings, losing the audio.",
    "steps_label": "Steps:",
    "open_settings": "Open Tworks settings",
    "skip": "Skip (I might lose recordings)"
  },
  "force_upgrade": {
    "title": "Update Tworks",
    "subtitle": "This version is no longer supported. Update from the store to keep using the app.",
    "go_to_store": "Go to the store"
  },
  "recovery": {
    "title": "Interrupted recordings",
    "subtitle_one": "We found {n} unsent recording from a previous session.",
    "subtitle_other": "We found {n} unsent recordings from a previous session.",
    "discard": "Discard",
    "recover": "Recover",
    "recover_unavailable": "Recovery not available yet",
    "discard_all": "Discard all recordings",
    "toast_recovered": "Recording recovered successfully.",
    "toast_unavailable": "Automatic recovery is not available yet. You can discard the file.",
    "toast_failed": "Couldn't recover the recording. Try again.",
    "toast_delete_failed": "Couldn't delete the file. Try again."
  }
}
